export default {
	noControls: {
		type: Boolean,
		default: false,
	},
	placeholder: {
		type: String,
		default: '',
	},
	value: {
		type: [String, Number],
		default: ''
	},
	required: {
		type: Boolean,
		default: false,
	},
	readonly: {
		type: Boolean,
		default: false,
	},
	disabled: {
		type: [Boolean, String],
		default: false
	},
	name: {
		type: [null, String],
		default: null
	},
	type: {
		type: String,
		default: 'text'
	},
	autocomplete: {
		type: String,
		default: 'off'
	},
	state: {
		type: [Boolean, String, null],
		default: null
	},
	autofocus: {
		type: Boolean,
		default: false
	},
	mask: {
		type: [String, null],
		default: null
	},
	loading: {
		type: [Boolean, null],
		default: null
	},
	noBackspace: {
		type: Boolean,
		default: false
	},
	max: {
		type: [String, Number, null],
		default: null
	},
	min: {
		type: [String, Number, null],
		default: null
	},
	size: {
		type: [String, null],
		default: null
	},
	formatter: null,
	validator: {
		type: Object,
		default: null
	},
	isValid: {
		type: Boolean,
		default: false
	}
};